import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@leadsnavi/ui-kit';

const DEFAULT_MAX_CHARS = 34;

/** 英文、数字、英文标点占 1 个字符，中文汉字占 2 个字符 */
const getDisplayLength = (str: string): number => {
  let length = 0;
  for (const char of str) {
    length += /[\u4e00-\u9fff]/.test(char) ? 2 : 1;
  }
  return length;
};

const truncateByDisplayLength = (str: string, maxLength: number): string => {
  let displayLength = 0;
  let result = '';
  for (const char of str) {
    const charLen = /[\u4e00-\u9fff]/.test(char) ? 2 : 1;
    if (displayLength + charLen > maxLength) break;
    result += char;
    displayLength += charLen;
  }
  return result;
};

export interface TruncatedTextWithTooltipProps {
  text: string;
  className?: string;
  maxChars?: number;
}

export const TruncatedTextWithTooltip: React.FC<TruncatedTextWithTooltipProps> = ({
  text,
  className,
  maxChars = DEFAULT_MAX_CHARS,
}) => {
  const displayValue = text || '-';
  const needsTooltip = displayValue !== '-' && getDisplayLength(displayValue) > maxChars;
  const displayText = needsTooltip ? truncateByDisplayLength(displayValue, maxChars - 2) + '...' : displayValue;

  if (needsTooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`cursor-pointer break-words w-full min-w-0 ${className ?? ''}`}>{displayText}</div>
        </TooltipTrigger>
        <TooltipContent className="max-w-md">
          <p className="whitespace-normal break-words">{displayValue}</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return <div className={className}>{displayText}</div>;
};
